import React, { useState } from 'react';
import { Book, Lock, Users, ArrowLeft, Edit2 } from 'react-feather';
import ImageFadeIn from 'react-image-fade-in';
import longWritesBooks from '../../../images/long-writes-books.png';
import styles from '../Writes.module.scss';
import { useNavigate } from '@reach/router';

const SelectWrite = ({
    selectedClass,
    selectedGroup,
    navigateBack,
    setSelectedWriteType,
}) => {
    const [showIsp, setShowIsp] = useState(false);
    const navigate = useNavigate();

    if (selectedClass || selectedGroup) {
        return (
            <>
                <div className='page-header'>
                    <div className='page-header__content'>
                        <div className='page-header__content__inner'>
                            <h2 className='page-header__content__title'>
                                <Users />
                                {selectedClass
                                    ? selectedClass.name
                                    : selectedGroup.name}
                            </h2>
                        </div>
                    </div>
                    <div className='page-header__actions'>
                        <button
                            onClick={navigateBack}
                            className='btn-reset u-display-flex u-align-center u-text-dark'
                        >
                            <ArrowLeft className='u-m-right-1' /> Back
                        </button>
                    </div>
                </div>
                {/* {showIsp ? <StartIsp selectedClass={selectedClass} /> : */}

                <>
                    <div className='row'>
                        <div className='col-md-8 u-display-flex'>
                            <div
                                className={`${styles.unlockedWrites} u-text-center u-relative`}
                                onClick={() => {
                                    setSelectedWriteType('long');
                                    navigate(
                                        `/startWrite/selectCategory/${selectedClass ? selectedClass.id : selectedGroup.id}`
                                    );
                                }}
                            >
                                <div className={styles.unlockedWritesTitle}>
                                    <Book size={40} />
                                    <h1 className='u-m-top-2 u-m-base-2'>
                                        Long write
                                    </h1>
                                </div>

                                <div className={styles.unlockedWritesContent}>
                                    <div
                                        className={
                                            styles.unlockedWritesDescription
                                        }
                                    >
                                        <p
                                            className={`${styles.writeDescription} u-m-base-2`}
                                        >
                                            Pupils will write chapters in
                                            response to a story starter. After
                                            submitting their chapter,
                                            Starcasting will begin - pupils will
                                            rate each other’s work and the
                                            highest rated chapter will be added
                                            to the story.
                                        </p>
                                        <p className={styles.writeDescription}>
                                            Repeat this process until you have
                                            your final story - read your book
                                            digitally or have hard copies
                                            printed.
                                        </p>
                                    </div>
                                    <ImageFadeIn
                                        className={
                                            styles.unlockedWritesBooksImage
                                        }
                                        width={190}
                                        src={longWritesBooks}
                                        alt=''
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 u-display-flex'>
                            <div
                                className={`${styles.lockedWrites} u-text-center u-relative`}
                            >
                                <Edit2 size={40} />
                                <Lock size={28} className={styles.lockIcon} />
                                <h1 className='u-m-top-2 u-m-base-2'>
                                    Short write
                                </h1>
                                <h2>
                                    Coming soon
                                </h2>
                                <p className='u-m-base-2'>
                                    Pupils will write once in response to a
                                    teacher prompt. Once submitted, short writes
                                    will be shared with other pupils in the
                                    class to suggest edits.{' '}
                                </p>
                                <p>
                                    Teachers will be able to access the "version
                                    history" of each pupil’s writing including
                                    the edit suggestions and final outcome.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* <div onClick={() => setShowIsp(true)} className={styles.isp}>
                        <div><ImageFadeIn width={190} src={ispLogo} alt='' /></div>
                        <div className={styles.ispTitle}>International Schools Partnership writing project</div>
                    </div> */}
                </>
                {/* } */}
            </>
        );
    }

    return <></>;
};

export default SelectWrite;
